import alternaleaf from '@montugroup/themes/brands/alternaleaf';
import uMeds from '@montugroup/themes/brands/uMeds';
import alternaleafLoader from '../assets/loaders/alternaleaf_loader.json';
import uMedsLoader from '../assets/loaders/uMeds_loader.json';
import { AppId } from './id';
export const appConfigs = {
    [AppId.uMeds]: {
        datadogClientToken: 'pubd3cbff4f9b7886592c7abb56e9bcaba3',
        datadogService: 'umeds.com.au',
        helpCentreDomain: 'https://support.umeds.com.au',
        loader: uMedsLoader,
        survicateBaseUrl: 'https://survey.survicate.com',
        survicateImprovementSurveyId: '1d9318e848af1f20',
        survicateNpsSurveyId: '1d9318e848af1f20',
        survicateWorkspaceKey: 'ef1a15400ab3a5762ddd611fe50387c1',
        theme: uMeds,
        zendeskTags: ['umeds chatbot'],
        override: {
            palette: {
                header: {
                    main: '#042B37',
                    contrast: '#FFFFFF',
                },
                launcher: {
                    main: '#042B37',
                    contrast: '#FF9845',
                },
                message: {
                    main: '#ffb77d',
                    contrast: '#181b25',
                },
            },
        },
    },
    [AppId.alternaleaf]: {
        datadogClientToken: 'pubd3cbff4f9b7886592c7abb56e9bcaba3',
        datadogService: 'alternaleaf.com.au',
        helpCentreDomain: 'https://support.alternaleaf.com.au',
        loader: alternaleafLoader,
        survicateBaseUrl: 'https://survey.survicate.com',
        survicateImprovementSurveyId: 'd60dc694fb5c3f7b',
        survicateNpsSurveyId: 'd60dc694fb5c3f7b',
        survicateWorkspaceKey: '79e569f19686bd19af22d62257cd6e38',
        theme: alternaleaf,
        zendeskTags: ['alternaleaf chatbot'],
        override: {
            palette: {
                header: {
                    main: '#CEEDFF',
                    contrast: '#300431',
                },
                launcher: {
                    main: '#CEEDFF',
                    contrast: '#CEEDFF',
                    icon: '#300431',
                },
                message: {
                    main: '#CEEDFF',
                    contrast: '#300431',
                },
            },
        },
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbmZpZy9hcHAudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxXQUFXLE1BQU0sdUNBQXVDLENBQUM7QUFDaEUsT0FBTyxLQUFLLE1BQU0saUNBQWlDLENBQUM7QUFFcEQsT0FBTyxpQkFBaUIsTUFBTSwyQ0FBMkMsQ0FBQztBQUMxRSxPQUFPLFdBQVcsTUFBTSxxQ0FBcUMsQ0FBQztBQUM5RCxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sTUFBTSxDQUFDO0FBZ0I3QixNQUFNLENBQUMsTUFBTSxVQUFVLEdBQTZCO0lBQ2xELENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxFQUFFO1FBQ2Isa0JBQWtCLEVBQUUscUNBQXFDO1FBQ3pELGNBQWMsRUFBRSxjQUFjO1FBQzlCLGdCQUFnQixFQUFFLDhCQUE4QjtRQUNoRCxNQUFNLEVBQUUsV0FBVztRQUNuQixnQkFBZ0IsRUFBRSw4QkFBOEI7UUFDaEQsNEJBQTRCLEVBQUUsa0JBQWtCO1FBQ2hELG9CQUFvQixFQUFFLGtCQUFrQjtRQUN4QyxxQkFBcUIsRUFBRSxrQ0FBa0M7UUFDekQsS0FBSyxFQUFFLEtBQUs7UUFDWixXQUFXLEVBQUUsQ0FBQyxlQUFlLENBQUM7UUFDOUIsUUFBUSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRTtvQkFDTixJQUFJLEVBQUUsU0FBUztvQkFDZixRQUFRLEVBQUUsU0FBUztpQkFDcEI7Z0JBQ0QsUUFBUSxFQUFFO29CQUNSLElBQUksRUFBRSxTQUFTO29CQUNmLFFBQVEsRUFBRSxTQUFTO2lCQUNwQjtnQkFDRCxPQUFPLEVBQUU7b0JBQ1AsSUFBSSxFQUFFLFNBQVM7b0JBQ2YsUUFBUSxFQUFFLFNBQVM7aUJBQ3BCO2FBQ0Y7U0FDRjtLQUNGO0lBQ0QsQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUU7UUFDbkIsa0JBQWtCLEVBQUUscUNBQXFDO1FBQ3pELGNBQWMsRUFBRSxvQkFBb0I7UUFDcEMsZ0JBQWdCLEVBQUUsb0NBQW9DO1FBQ3RELE1BQU0sRUFBRSxpQkFBaUI7UUFDekIsZ0JBQWdCLEVBQUUsOEJBQThCO1FBQ2hELDRCQUE0QixFQUFFLGtCQUFrQjtRQUNoRCxvQkFBb0IsRUFBRSxrQkFBa0I7UUFDeEMscUJBQXFCLEVBQUUsa0NBQWtDO1FBQ3pELEtBQUssRUFBRSxXQUFXO1FBQ2xCLFdBQVcsRUFBRSxDQUFDLHFCQUFxQixDQUFDO1FBQ3BDLFFBQVEsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDUCxNQUFNLEVBQUU7b0JBQ04sSUFBSSxFQUFFLFNBQVM7b0JBQ2YsUUFBUSxFQUFFLFNBQVM7aUJBQ3BCO2dCQUNELFFBQVEsRUFBRTtvQkFDUixJQUFJLEVBQUUsU0FBUztvQkFDZixRQUFRLEVBQUUsU0FBUztvQkFDbkIsSUFBSSxFQUFFLFNBQVM7aUJBQ2hCO2dCQUNELE9BQU8sRUFBRTtvQkFDUCxJQUFJLEVBQUUsU0FBUztvQkFDZixRQUFRLEVBQUUsU0FBUztpQkFDcEI7YUFDRjtTQUNGO0tBQ0Y7Q0FDRixDQUFDIn0=